
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Input from '../Input/index.vue'

@Observer
@Component({
  components: {
    Input
  }
})
export default class WeChat extends Vue {
  wechat: string = ''

  get UserStore() {
    return this.$store.$storeUser
  }

  async onSubmit() {
    try {
      if (!this.wechat) {
        this.$msg('微信号不能为空')
        return
      }

      await this.UserStore.onUpdateUserInfo({
        id: this.UserStore.UserInfo.id,
        wxUsername: this.wechat
      })

      this.$msg('保存成功', 'success')

      return true
    } catch (error) {}
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
